import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { text: String };

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => {
      const button = this.element.querySelector('button') || this.element;
      const originalText = button.innerHTML;
      const icon = button.querySelector('i');
      const iconClass = icon ? icon.className : '';

      button.innerHTML = `<i class="${iconClass}"></i> Copied!`;
      setTimeout(() => {
        button.innerHTML = originalText;
      }, 2000);

      window.open('https://claude.ai/code', '_blank');
    });
  }
}
